export default [

    {
        path: "/pay",
        name: "pay",
        component: () => import("./Index"),
        meta: {
            permiss: ['PAY_DEVICE_SERVICE_CHARGE'],
            title: "服务费"
        }
    },
]